import { useState ,useEffect} from 'react';
import React from "react";
import { BASE_URL , DateFormat,DateTimeFormat} from '../Components/Constant';
import ApiService from '../Components/apiService';
import { EditOutlined, CopyOutlined, DeleteOutlined, PhoneOutlined, CloseOutlined } from '@ant-design/icons';
import { Table,Checkbox, Typography, Tooltip, Popconfirm, Button, message, Card, Row,Col,Spin } from 'antd';
// import CreateTigger from './CreateTrigger';
import CreateTigger from './CreateTrigger';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {convertDateToUserTimezone} from '../Components/Utility';

const TriggersList=({object,showAllTriggers})=>{

    const { Title,Link } = Typography;


    const [allTriggers,setAllTriggers]=useState([]);
    // const [isCreatingTrigger,setIsCreatingTrigger]=useState(false);
    const [isCreatingTrigger,setIsCreatingTrigger]=useState(false);
    const [selectedTrigger,setSelectedTrigger]=useState();
    const [triggerDataOnEdit,setTriggerDataOnEdit] = useState();
    const [selectedTriggerData,setSelectedTriggerData] = useState();
    const [triggerId,setTriggerId] = useState('');
    const [loading,setLoading]=useState(true);
    const [pageSize,setPageSize]=useState(10);
    const triggerSecurity = useSelector((state) => state.data.items[0]);
    const navigate = useNavigate();
    
    useEffect(()=>{
        if(triggerSecurity?.system_settings?.triggers.view===false){
            message.error('You dont have permission to view Triggers');
            return;
        }
        fetchAllTriggers();
    },[object]);

   

    const fetchAllTriggers=async()=>{
        try {
            setLoading(true);
            const apiService = new ApiService(
              `${BASE_URL}/get_trigger_by_model/${object.name}/10/0`,
              { 'Content-Type': 'application/json' },
              'GET'
            );

            const res=await apiService.makeCall(navigate);
            setAllTriggers(res.triggers);


        }catch(error){
        }
        finally{
            setLoading(false);
        }
    }

    const handleEdit=async (trigger)=>{
        if(triggerSecurity?.system_settings?.triggers.edit===false){
            message.error('You dont have permission to edit Trigger');
            return;
        }
        try {
            const apiService = new ApiService(
              `${BASE_URL}/get_trigger/${trigger.trigger_name}`,
              { 'Content-Type': 'application/json' },
              'GET'
            );

            const res=await apiService.makeCall(navigate);
            setTriggerDataOnEdit(res.Trigger);
            setSelectedTrigger(res.Trigger);
            setSelectedTriggerData(trigger);
            setIsCreatingTrigger(true);
            setTriggerId(trigger._id);
        }catch(error){
        }
        

    }

    const handleDelete= async (record)=>{
        if(triggerSecurity?.system_settings?.triggers.delete===false){
            message.error('You dont have permission to delete Trigger');
            return;
        }
        try {
            setLoading(true);
            const apiService = new ApiService(
              `${BASE_URL}/delete_trigger/${record.trigger_name}`,
              { "Content-Type": "application/json" },
              "DELETE"
            );
            const response = await apiService.makeCall(navigate);
            if(response.success === true){
                message.success("Trigger deleted successfully");
            }
            fetchAllTriggers();
          } 
          catch (error) {
            message.error("Failed to delete trigger");
          }finally{
            setLoading(false);
          }


    }

    const handleCreate=()=>{
        setSelectedTrigger();
        // setIsCreatingTrigger(true);
        setTriggerId('');
        setSelectedTriggerData('');
        if(triggerSecurity?.system_settings?.triggers.create===false){
            message.error('You dont have permission to create Trigger');
            return;
        }

        setIsCreatingTrigger(true);
    }

    const columns = [

        {
            title: 'Trigger Name',
            dataIndex: 'trigger_name',
            key: 'trigger_name',
            sorter: (a, b) => a.trigger_name.localeCompare(b.trigger_name),
            render: (text, record) => (
                <Link
                  onClick={() => handleEdit(record)}
                  style={{ cursor: "pointer" }}
                >
                  {text}
                </Link>
              ),
          
        },
        {
            title: 'Active',
            dataIndex: 'active',
            key: 'active',
            render: (text, record) => (
                <Checkbox 
                    checked={record.active} // Bind the checkbox to the record's active status
                    disabled // Make it read-only (optional, depending on your requirements)
                >
                    {/* Optional: Add label or leave it blank */}
                </Checkbox>
            ),
    
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: 'created_at',
            sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
            render: (text) => (
                text && dayjs(text).isValid()
                  ? convertDateToUserTimezone(text, DateTimeFormat)
                  : ''
              ),
        
            
        },
        {
            title: 'Updated At',
            dataIndex: 'updated_at',
            key: 'updated_at',
            sorter: (a, b) => new Date(a.updated_at) - new Date(b.updated_at),
            render: (text) => (
                text && dayjs(text).isValid()
                  ? convertDateToUserTimezone(text, DateTimeFormat)
                  : ''
              ),
        
        },
        {
            title: 'Order',
            dataIndex: 'order',
            key: 'order',
            sorter: (a, b) => a.order - b.order,
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <>
                    <Tooltip title="Edit">
                        <EditOutlined
                            onClick={() =>
                                handleEdit(record)}
                            style={{ marginRight: 5, fontSize: '12px', cursor: 'pointer' }}
                        />
                    </Tooltip>
                    <Tooltip title="Delete">
                        <Popconfirm
                            title="Are you sure you want to delete this item?"
                            onConfirm={() => handleDelete(record)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <DeleteOutlined style={{ color: 'red', marginRight: 5, fontSize: '12px', cursor: 'pointer' }} />
                        </Popconfirm>
                    </Tooltip>
                </>
            ),
        },
    ];


    return(
        <>
            {!isCreatingTrigger && 
                    <>
                        <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
                            <Col>
                                <Title level={4} >Triggers</Title>
                            </Col>
                            <Col>
                                <Button type="primary" onClick={handleCreate}>Create Trigger</Button>
                            </Col>
                        </Row>
                        <Spin spinning={loading} size="small">
                        <Table
                            columns={columns}
                            dataSource={allTriggers}
                            scroll={{ x: 'max-content', y: 550 }}
                            pagination={{
                                pageSize: pageSize,
                                showSizeChanger: true,
                                pageSizeOptions: ['10', '20', '50', '100'],
                                onChange: (page, pageSize) => {
                                    setPageSize(pageSize);
                                },              
                                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                            }}
                        />
                        </Spin>
                    </>
            }
            {isCreatingTrigger && 
                <CreateTigger
                object={object} 
                onBack={() => setIsCreatingTrigger(false)}
                fetchAllTriggers={fetchAllTriggers}
                selectedTrigger={selectedTrigger}
                selectedTriggerData={selectedTriggerData}
                triggerId={triggerId}
                />
            }
        </>
    );

}

export default TriggersList;
